const hasFilterChanged = ({ oldFilter, newFilter }) => {
  for (const key in oldFilter) {
    if (Object.prototype.hasOwnProperty.call(oldFilter, key)) {
      const oldValue = oldFilter[key];
      const newValue = newFilter[key];

      if (newValue === undefined) return true;

      for (const prop in oldValue) {
        if (Object.prototype.hasOwnProperty.call(oldValue, prop)) {
          if (JSON.stringify(oldValue[prop]) !== JSON.stringify(newValue[prop])) {
            return true;
          }
        }
      }
    }
  }
  return false;
};

const sortFilterTags = ({ list, isCheckField = false, fieldName = 'value', isRun = false }) => {
  let neList = list?.length > 0 ? [...list] : [];
  return neList?.sort((a, b) => {
    if (isRun) {
      const numA = Number(a.replace('RUN').split('-')[1] || 0);
      const numN = Number(b.replace('RUN').split('-')[1] || 0);
      return numA - numN;
    } else {
      const valueA = isCheckField ? a[fieldName] : a;
      const valueB = isCheckField ? b[fieldName] : b;
      const isNumA = /^\d/.test(valueA);
      const isNumB = /^\d/.test(valueB);

      if (isNumA && !isNumB) return 1;
      if (!isNumA && isNumB) return -1;

      return valueA?.localeCompare(valueB, undefined, { sensitivity: 'base' });
    }
  });
};

export { hasFilterChanged, sortFilterTags };
